export default "__VITE_ASSET__DjKSu2P2__"